import { Injectable } from '@angular/core';

@Injectable()
export class HtmlHelperService {

  constructor() { }

  //access DOM to modify height of all textarea tags
  adjustHeightAllTextareas(){
    
      let textareaList = Array.from(document.getElementsByTagName('textarea') as NodeListOf<HTMLElement>);
      for (let textarea of textareaList){
        // console.log('auto-sizing textarea', textarea);
        textarea.style.overflow = 'hidden';
        textarea.style.height = '0px';
        textarea.style.height = textarea.scrollHeight + 'px';
      }
  }

  //access DOM to modify height of the textarea tag targeted by the $e event
  adjustHeightSingleTextarea(elementIdWithoutHash:string){
    let textarea = document.getElementById(elementIdWithoutHash);
    if(textarea == null){
      return;
    }
    textarea.style.overflow = 'hidden';
    textarea.style.height = '0px';
    textarea.style.height = textarea.scrollHeight + 'px';
  }

}



// WEBPACK FOOTER //
// ./src/app/services/utility/html-helper.service.ts